module.exports = __webpack_public_path__ + "img/charity_1.2381be23.png";